import { FileMediaLinks, Pagination } from 'src/api/common';
import api from './baseApi';

export enum MessageStatus {
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  REJECTED = 'REJECTED',
}

export enum MessageType {
  MESSAGE = 'MESSAGE',
  REPLY = 'REPLY',
}

export interface Message {
  _id: string;
  createdAt: string;
  updatedAt: string;

  title: string;
  msgType: MessageType;
  status: MessageStatus;

  tribe_id: string;
  leader_id: string;
  leader_name: string;

  user_id: string;
  user_name: string;
  recognition_event_id?: string;

  video_id: string;
  video: FileMediaLinks;
  video_url: string;
  thumbnail: string;
  animated_gif: string;

  response: string;
  response_data?: Message;
}

export interface AllMessagesResponse {
  result: Message[];
  replies: Message[];
  pagination: Pagination;
}

export const CIRCLE_MESSAGES_PAGE = 1;
export const CIRCLE_MESSAGES_PAGE_SIZE = 12;

type MessageListParams = {
  tribe_id?: string;
  page?: number;
  pageSize?: number;
};

const compactParams = (params?: MessageListParams) => {
  if (!params) {
    return undefined;
  }

  const entries = Object.entries(params).filter(
    ([, value]) => value !== undefined
  );

  return entries.length ? Object.fromEntries(entries) : undefined;
};

export const messagesApi = {
  getMessagesMember: async (
    params?: MessageListParams
  ): Promise<AllMessagesResponse> => {
    const axiosResponse = await api.get(`messages/member`, {
      params: compactParams(params),
    });
    return axiosResponse.data;
  },

  getMessagesLeader: async (
    tribe_id: string,
    params?: Pick<MessageListParams, 'page' | 'pageSize'>
  ): Promise<AllMessagesResponse> => {
    const axiosResponse = await api.get(`tribes/${tribe_id}/messages/leader`, {
      params: compactParams({ tribe_id, ...params }),
    });
    return axiosResponse.data;
  },

  sendFromLeader: async (data: {
    tribe_id: string;
    title: string;
    user_id: string;
    video_id: string;
    recognition_event_id?: string;
  }): Promise<Message> => {
    const axiosResponse = await api.post(`messages`, data);
    return axiosResponse.data.result;
  },

  sendReplyFromMember: async (
    message_id: string,
    data: { title: string; video_id: string }
  ): Promise<Message> => {
    const axiosResponse = await api.post(`messages/${message_id}/reply`, data);
    return axiosResponse.data.result;
  },
};
